import { Button, Modal, Select, TextInput } from 'flowbite-react';
import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Common/Loader';
import { DeliveryAsset } from '../../Models/DeliveryAsset';
import AssetApi from '../../Api/AssetApi';
import { Asset } from '../../Models/Asset';
import DeliveryApi from '../../Api/DeliveryApi';
import { Inspection } from '../../Models/Inspection';
import InspectionApi from '../../Api/InspectionApi';
import { InspectionCustom } from '../../Models/InspectionCustom';
import { InspectionAsset } from '../../Models/InspectionAsset';
import { displayDateOnly } from '../../Utils';
import { useAppDispatch, useAppSelector } from '../../Reducers/store';
import { fetchAssetStatuses } from '../../Actions/CommonFields';
import { SopformImageTypeEnum } from '../../Models/SopformImage';

export default function InspectionViewAssetModal({
  show,
  setShow,
  selectedInspection,
  setselectedInspection,
}: {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  selectedInspection: InspectionCustom | null;
  setselectedInspection: React.Dispatch<
    React.SetStateAction<InspectionCustom | null>
  >;
}) {
  const { assetStatuses } = useAppSelector((state) => state.commonFields);
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [selectedAsset, setselectedAsset] = useState<InspectionAsset>();
  const [inspection, setinspection] = useState<Inspection>({
    id: 0,
    userId: null,
    typeId: null,
    mileage: null,
    dateCreated: null,

    inspectionAssets: [],
    user: null,
  });
  const [formData, setFormData] = useState<Asset>({
    id: 0,
    name: null,
    number: null,
    dateCreated: null,
    statusId: 1,
    typeId: 1,
    vin: null,
    color: null,
    originalMileage: null,
    currentMileage: null,
    currentMileageDate: null,
    year: null,
    make: null,
    model: null,
    purchasePrice: null,

    assetQuantities: [],
    status: null,
    type: null,
  });
  const handleSetInitialValues = () => {
    const values = selectedAsset
      ? {
          ...selectedAsset.asset,
        }
      : {
          id: 0,
          name: null,
          number: null,
          dateCreated: null,
          statusId: 1,
          typeId: 1,
          vin: null,
          color: null,
          originalMileage: null,
          currentMileage: null,
          currentMileageDate: null,
          year: null,
          make: null,
          model: null,
          purchasePrice: null,

          status: null,
          type: null,
        };
    setFormData(values as Asset);
  };

  useEffect(() => {
    handleSetInitialValues();
  }, [selectedAsset]);

  const getReferences = async () => {
    if (!assetStatuses.length) {
      await Promise.all([dispatch(fetchAssetStatuses())]);
    }
  };

  const getInspection = () => {
    if (selectedInspection) {
      setIsLoading(true);
      return InspectionApi.getInspection(selectedInspection?.id.toString())
        .then((res) => {
          setinspection(res.data);
          setselectedAsset(
            res.data.inspectionAssets.find(
              (x) => x.assetId === selectedInspection.assetId
            )
          );
          setIsLoading(false);
        })
        .catch((err) => {
          toast.error('Error');
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (show) {
      getReferences();
      getInspection();
    }
  }, [show]);

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    setIsLoading(true);
    return AssetApi.addUpdateAsset(formData)
      .then((res) => {
        if (res.data.success) {
          toast.success('Success');
          setIsLoading(false);
          setButtonDisabled(false);
          onCloseModal();
        } else {
          toast.error(res.data.message);
          setIsLoading(false);
          setButtonDisabled(false);
        }
      })
      .catch((err) => {
        toast.error('Error: ' + err);
        setIsLoading(false);
        setButtonDisabled(false);
      });
  };

  function onCloseModal() {
    setselectedInspection(null);
    setIsLoading(false);
    setShow(false);
  }

  const damageLeaksImages = selectedAsset?.sopform?.sopformImages?.filter(
    (x) => x.typeId === SopformImageTypeEnum.DamageLeaks
  );
  const lightsSignalsBrakesImages =
    selectedAsset?.sopform?.sopformImages?.filter(
      (x) => x.typeId === SopformImageTypeEnum.LightsSignalsBrakes
    );
  const safetyEquipmentPpeImages =
    selectedAsset?.sopform?.sopformImages?.filter(
      (x) => x.typeId === SopformImageTypeEnum.SafetyEquipmentPpe
    );

  return (
    <>
      <Modal show={show} size='5xl' onClose={onCloseModal} popup>
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <div className='relative'>
            {isLoading && <Loader />}
            <div className='w-full'>
              <div className='w-full'>
                <div className='mx-1 flex items-end justify-center'>
                  <div className='flex flex-1 justify-center'>
                    <h1 className='text-gray-900 font-bold text-4xl'>
                      Inspection for {selectedAsset?.asset?.name}
                    </h1>
                  </div>
                </div>
              </div>
              <div>
                <div className='container mx-auto p-2'>
                  <div className='md:flex no-wrap md:-mx-2 '>
                    <div className='w-full'>
                      <div className='bg-white'>
                        <hr className='bg-gray-300 h-[5px]'></hr>
                        <div className='grid grid-cols-[25%_75%] lg:grid-cols-[20%_80%] text-xl'>
                          <div>Date:</div>
                          <div>
                            {displayDateOnly(new Date(inspection.dateCreated!))}
                          </div>
                        </div>
                        <div className='grid grid-cols-[25%_75%] lg:grid-cols-[20%_80%] text-xl'>
                          <div>Driver:</div>
                          <div>{selectedInspection?.userFullName}</div>
                        </div>
                        <div className='grid grid-cols-[25%_75%] lg:grid-cols-[20%_80%] text-xl'>
                          <div>Results:</div>
                          <div>
                            <div className='content-center'>
                              I confirm my delivery vehicle contains no visible
                              damage or leaks.
                            </div>
                            <div
                              className={`${
                                selectedAsset?.sopform?.damageLeaks === false
                                  ? 'text-red-700'
                                  : 'text-green-700'
                              }`}
                            >
                              {selectedAsset?.sopform?.damageLeaks === true
                                ? 'Pass'
                                : 'Fail: ' +
                                  selectedAsset?.sopform?.damageLeaksNotes}
                            </div>
                            {damageLeaksImages &&
                              damageLeaksImages.length > 0 && (
                                <div className='flex overflow-auto'>
                                  {damageLeaksImages.map((x) => (
                                    <img
                                      key={x.id}
                                      src={x.imageUrl!}
                                      className='h-28'
                                    />
                                  ))}
                                </div>
                              )}
                            <hr className='bg-gray-300 h-[2px] mb-2'></hr>
                            <div className='content-center'>
                              I confirm that all lights, signals, and brakes are
                              functioning properly.
                            </div>
                            <div
                              className={`${
                                selectedAsset?.sopform?.lightsSignalsBrakes ===
                                false
                                  ? 'text-red-700'
                                  : 'text-green-700'
                              }`}
                            >
                              {selectedAsset?.sopform?.lightsSignalsBrakes ===
                              true
                                ? 'Pass'
                                : 'Fail: ' +
                                  selectedAsset?.sopform
                                    ?.lightsSignalsBrakesNotes}
                            </div>
                            {lightsSignalsBrakesImages &&
                              lightsSignalsBrakesImages.length > 0 && (
                                <div className='flex overflow-auto'>
                                  {lightsSignalsBrakesImages.map((x) => (
                                    <img
                                      key={x.id}
                                      src={x.imageUrl!}
                                      className='h-28'
                                    />
                                  ))}
                                </div>
                              )}
                            <hr className='bg-gray-300 h-[2px] mb-2'></hr>
                            <div className='content-center'>
                              I confirm that all necessary safety equipment is
                              on board, including fire extinguishers, spill
                              kits, and personal protective equipment(PPE).
                            </div>
                            <div
                              className={`${
                                selectedAsset?.sopform?.safetyEquipmentPpe ===
                                false
                                  ? 'text-red-700'
                                  : 'text-green-700'
                              }`}
                            >
                              {selectedAsset?.sopform?.safetyEquipmentPpe ===
                              true
                                ? 'Pass'
                                : 'Fail: ' +
                                  selectedAsset?.sopform
                                    ?.safetyEquipmentPpenotes}
                            </div>
                            {safetyEquipmentPpeImages &&
                              safetyEquipmentPpeImages.length > 0 && (
                                <div className='flex overflow-auto'>
                                  {safetyEquipmentPpeImages.map((x) => (
                                    <img
                                      key={x.id}
                                      src={x.imageUrl!}
                                      className='h-28'
                                    />
                                  ))}
                                </div>
                              )}
                            <hr className='bg-gray-300 h-[2px] mb-2'></hr>
                          </div>
                        </div>
                        <form id='DeliveryAssetForm' onSubmit={onSubmit}>
                          <div className='grid grid-cols-[25%_75%] lg:grid-cols-[20%_80%] text-xl'>
                            <div>Current Status:</div>
                            <div className='w-full'>
                              <Select
                                id='statusId'
                                name='statusId'
                                onChange={handleChangeSelect}
                                value={formData.statusId ?? ''}
                                sizing='md'
                                required
                              >
                                <option value={''}>(Select)</option>
                                {assetStatuses.map((obj) => (
                                  <option key={obj.id} value={obj.id}>
                                    {obj.name}
                                  </option>
                                ))}
                              </Select>
                            </div>
                          </div>
                          <div className='flex justify-end pt-2'>
                            <Button
                              disabled={buttonDisabled}
                              type='submit'
                              className='buttonMain'
                              form='DeliveryAssetForm'
                            >
                              Save
                            </Button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
